import React from 'react';
import { Link } from 'react-router-dom';

import { Page } from '@occc-app/design-system';
import { TableContainer, Button, TableHeader, SearchForm, AddIcon } from '@occc/ui-design-system';
import { useChainId } from '@occc-app/Chain/hooks';
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { useSearchParams } from '@occc-app/hooks/useSearchParams';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { useGetSegments } from '@occc/feat-segments';
import { SegmentsTable } from './SegmentsTable';

import { routeCreator } from '../utils';

const PAGE_TITLE = 'Segments';

export const SegmentListPage = () => {
  const [paginationInfo, onPageChange] = usePaginationParams();
  const [search, setSearch] = useSearchParams();

  const chainId = useChainId();

  const isUserPermittedToCreateSegment = useIsUserPermittedTo(Feature.SEGMENT_CREATE);
  const isUserPermittedToEditSegment = useIsUserPermittedTo(Feature.SEGMENT_EDIT);
  const isUserPermittedToDeleteSegment = useIsUserPermittedTo(Feature.SEGMENT_DELETE);

  const { loading, error, data, paginationProps } = useGetSegments({
    filter: {
      search,
      isDeleted: false,
      chainIdEquals: chainId,
    },
    paginationInfo,
    onPageChange,
  });

  const actions = isUserPermittedToCreateSegment && (
    <Button
      color='secondary'
      variant='contained'
      component={Link}
      startIcon={<AddIcon />}
      to={routeCreator.create()}
      role='button'
    >
      create new segment
    </Button>
  );

  return (
    <Page browserTabTitle={PAGE_TITLE} actions={actions} pageHeaderProps={{ title: PAGE_TITLE }}>
      <TableContainer>
        <TableHeader
          title={PAGE_TITLE}
          actions={
            <SearchForm onSubmit={({ search }) => setSearch(search)} initialValues={{ search }} />
          }
        />
        <SegmentsTable
          segments={data}
          loading={loading}
          error={error}
          paginationProps={paginationProps}
          isUserPermittedToEditSegment={isUserPermittedToEditSegment}
          isUserPermittedToDeleteSegment={isUserPermittedToDeleteSegment}
        />
      </TableContainer>
    </Page>
  );
};
